module.exports = __webpack_public_path__ + "img/40_69_015_580.3573fb30.jpg";